$gzConsoleAssetsPrefix: 'app/webcomponents/';

/**
*   IBMPlex
*/

@font-face {
  font-family: 'IBMPlex';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex/IBMPlexSans-Light.otf') format('opentype');
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: 'IBMPlex';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex/IBMPlexSans-Regular.otf') format('opentype');
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: 'IBMPlex';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex/IBMPlexSans-Medium.otf') format('opentype');
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: 'IBMPlex';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex/IBMPlexSans-Bold.otf') format('opentype');
  font-style: normal;
  font-weight: 700;
}

/**
*   IBMPlex_Mono
*/

@font-face {
  font-family: 'IBMPlex Mono';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex_Mono/IBMPlexMono-Light.otf') format('opentype');
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: 'IBMPlex Mono';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex_Mono/IBMPlexMono-Regular.otf') format('opentype');
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: 'IBMPlex Mono';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex_Mono/IBMPlexMono-Medium.otf') format('opentype');
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: 'IBMPlex Mono';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/IBMPlex_Mono/IBMPlexMono-Bold.otf') format('opentype');
  font-style: normal;
  font-weight: 700;
}

/**
*   Montserrat
*/
@font-face {
  font-family: 'Montserrat';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/Montserrat/Montserrat-Light.ttf') format('truetype');
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: 'Montserrat';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/Montserrat/Montserrat-Regular.ttf') format('truetype');
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: 'Montserrat';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/Montserrat/Montserrat-Medium.ttf') format('truetype');
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: 'Montserrat';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/Montserrat/Montserrat-SemiBold.ttf') format('truetype');
  font-style: normal;
  font-weight: 600;
}

@font-face {
  font-family: 'Montserrat';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/Montserrat/Montserrat-Bold.ttf') format('truetype');
  font-style: normal;
  font-weight: 700;
}

/**
*   Bitdefender
*   2024-09-19
*/
@font-face {
  font-family: 'bitdefender';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/icons/gz_main.eot?k69x6e');
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/icons/gz_main.eot?k69x6e#iefix') format('embedded-opentype'),
  url($gzConsoleAssetsPrefix + 'assets/fonts/icons/gz_main.ttf?k69x6e') format('truetype'),
  url($gzConsoleAssetsPrefix + 'assets/fonts/icons/gz_main.woff?k69x6e') format('woff'),
  url($gzConsoleAssetsPrefix + 'assets/fonts/icons/gz_main.svg?k69x6e#bitdefender') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'bitdefender' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-trial_card_3:before {
  content: "\e9ed";
}
.icon-trial_card_1:before {
  content: "\e9ee";
}
.icon-trial_card_2:before {
  content: "\e9ef";
}
.icon-product_trials:before {
  content: "\e9f0";
}
.icon-notification_negative:before {
  content: "\e9ec";
}
.icon-GravityZone_MobileSec:before {
  content: "\e9eb";
}
.icon-BD_Icon_Outline:before {
  content: "\e9e9";
}
.icon-GravityZone_New:before {
  content: "\e9ea";
}
.icon-menu_mobile_sec:before {
  content: "\e9e8";
}
.icon-container_hosts:before {
  content: "\e9aa";
}
.icon-menu_license:before {
  content: "\e9a9";
}
.icon-notification_info:before {
  content: "\e9a8";
}
.icon-container:before {
  content: "\e9a7";
}
.icon-win_vm:before {
  content: "\e9a5";
}
.icon-win_workstation:before {
  content: "\e9a6";
}
.icon-close_button:before {
  content: "\e9a4";
}
.icon-incident:before {
  content: "\e9a3";
}
.icon-user:before {
  content: "\e9a2";
}
.icon-attack_trigger_circle .path1:before {
  content: "\e98a";
  color: rgb(255, 255, 255);
}
.icon-attack_trigger_circle .path2:before {
  content: "\e98b";
  margin-left: -1em;
  color: rgb(155, 155, 155);
}
.icon-attack_trigger_panel:before {
  content: "\e98c";
}
.icon-attacker:before {
  content: "\e98d";
}
.icon-cloud_storage:before {
  content: "\e98e";
}
.icon-external_drive:before {
  content: "\e98f";
}
.icon-external_source_default_state .path1:before {
  content: "\e990";
  color: rgb(164, 164, 164);
}
.icon-external_source_default_state .path2:before {
  content: "\e991";
  margin-left: -1em;
  color: rgb(243, 243, 243);
}
.icon-external_source_panel:before {
  content: "\e992";
}
.icon-external_source_selected_state .path1:before {
  content: "\e993";
  color: rgb(0, 158, 224);
}
.icon-external_source_selected_state .path2:before {
  content: "\e994";
  margin-left: -1em;
  color: rgb(243, 243, 243);
}
.icon-external_source_selected_state .path3:before {
  content: "\e995";
  margin-left: -1em;
  color: rgb(0, 158, 224);
}
.icon-external_source_selected_state .path4:before {
  content: "\e996";
  margin-left: -1em;
  color: rgb(0, 158, 224);
}
.icon-external_source_selected_state .path5:before {
  content: "\e997";
  margin-left: -1em;
  color: rgb(0, 158, 224);
}
.icon-internal_source_panel:before {
  content: "\e998";
}
.icon-IOT:before {
  content: "\e999";
}
.icon-mobile_device:before {
  content: "\e99a";
}
.icon-next_button:before {
  content: "\e99b";
}
.icon-pause_button:before {
  content: "\e99c";
}
.icon-prev_button:before {
  content: "\e99d";
}
.icon-printer:before {
  content: "\e99e";
}
.icon-router:before {
  content: "\e99f";
}
.icon-start_button:before {
  content: "\e9a0";
}
.icon-stop_button:before {
  content: "\e9a1";
}
.icon-panel_remediation_actions:before {
  content: "\e985";
}
.icon-panel_handle:before {
  content: "\e986";
}
.icon-panel_details:before {
  content: "\e987";
}
.icon-edr_phase:before {
  content: "\e988";
}
.icon-edr_panel_investigation:before {
  content: "\e989";
}
.icon-icon-whatsnew:before {
  content: "\e984";
}
.icon-golden_image:before {
  content: "\e983";
}
.icon-download:before {
  content: "\e982";
}
.icon-download_circle:before {
  content: "\e981";
}
.icon-system_status:before {
  content: "\e980";
}
.icon-add:before {
  content: "\e97f";
}
.icon-sort_tables:before {
  content: "\e97e";
}
.icon-settings_tables:before {
  content: "\e97d";
}
.icon-remove_tables:before {
  content: "\e97c";
}
.icon-plus_filter_applied:before {
  content: "\e97b";
}
.icon-more_tables:before {
  content: "\e97a";
}
.icon-filter_tables:before {
  content: "\e979";
}
.icon-filter_tables_collapsed:before {
  content: "\e978";
}
.icon-fillters_applied_tables:before {
  content: "\e977";
}
.icon-edr_remote_connection:before {
  content: "\e976";
}
.icon-edr_remediation:before {
  content: "\e975";
}
.icon-edr_notes:before {
  content: "\e974";
}
.icon-edr_navigation:before {
  content: "\e973";
}
.icon-edr_nav_small:before {
  content: "\e972";
}
.icon-edr_nav_big:before {
  content: "\e971";
}
.icon-edr_last_update:before {
  content: "\e970";
}
.icon-edr_incident_info:before {
  content: "\e96f";
}
.icon-edr_graph:before {
  content: "\e96e";
}
.icon-edr_expand_group:before {
  content: "\e96d";
}
.icon-edr_events:before {
  content: "\e96c";
}
.icon-edr_collapse_group:before {
  content: "\e96b";
}
.icon-edr_alerts:before {
  content: "\e96a";
}
.icon-edr_critical_path:before {
  content: "\e969";
}
.icon-edr_drag:before {
  content: "\e968";
}
.icon-edr_collaps:before {
  content: "\e967";
}
.icon-edr_timeline:before {
  content: "\e966";
}
.icon-edr_filters:before {
  content: "\e965";
}
.icon-refresh_2:before {
  content: "\e964";
}
.icon-refresh:before {
  content: "\e963";
}
.icon-show_extra_columns:before {
  content: "\e962";
}
.icon-view_more_up:before {
  content: "\e961";
}
.icon-view_more_down:before {
  content: "\e960";
}
.icon-cloud_email_security:before {
  content: "\e95f";
}
.icon-checked_full:before {
  content: "\e95e";
}
.icon-menu_security_dash:before {
  content: "\e95d";
}
.icon-windows:before {
  content: "\e95c";
}
.icon-servers:before {
  content: "\e95b";
}
.icon-linux:before {
  content: "\e95a";
}
.icon-fullscreen:before {
  content: "\e959";
}
.icon-devices:before {
  content: "\e958";
}
.icon-apple:before {
  content: "\e957";
}
.icon-help_menu_ior:before {
  content: "\e956";
}
.icon-ior_options:before {
  content: "\e955";
}
.icon-add_search:before {
  content: "\e954";
}
.icon-menu_ntsa:before {
  content: "\e953";
}
.icon-menu_ior:before {
  content: "\e952";
}
.icon-menu_configure:before {
  content: "\e951";
}
.icon-menu_sandbox:before {
  content: "\e950";
}
.icon-menu_reports:before {
  content: "\e94f";
}
.icon-menu_qurantine:before {
  content: "\e94e";
}
.icon-menu_policy:before {
  content: "\e94d";
}
.icon-menu_network:before {
  content: "\e94c";
}
.icon-menu_edr:before {
  content: "\e94b";
}
.icon-menu_dashboard:before {
  content: "\e94a";
}
.icon-menu_companies:before {
  content: "\e949";
}
.icon-menu_collapse:before {
  content: "\e948";
}
.icon-menu_accounts:before {
  content: "\e947";
}
.icon-arrow_down:before {
  content: "\e946";
}
.icon-edr_review:before {
  content: "\e945";
}
.icon-edr_prevented:before {
  content: "\e944";
}
.icon-sandbox_clean:before {
  content: "\e943";
}
.icon-ghostr:before {
  content: "\e942";
}
.icon-recovery_manager:before {
  content: "\e941";
}
.icon-unsupported_sandbox:before {
  content: "\e940";
}
.icon-pending_sandbox:before {
  content: "\e93f";
}
.icon-sandbox_icon_small:before {
  content: "\e93e";
}
.icon-edr_blocked:before {
  content: "\e93d";
}
.icon-edr_action_nedeed:before {
  content: "\e93c";
}
.icon-storage_protection:before {
  content: "\e93b";
}
.icon-edit:before {
  content: "\e93a";
}
.icon-delete:before {
  content: "\e939";
}
.icon-add_favorites:before {
  content: "\e938";
}
.icon-mglass_search:before {
  content: "\e937";
}
.icon-more_info:before {
  content: "\e936";
}
.icon-show_all:before {
  content: "\e935";
}
.icon-show:before {
  content: "\e934";
}
.icon-show_hidden:before {
  content: "\e933";
}
.icon-hide:before {
  content: "\e932";
}
.icon-hide_hidden:before {
  content: "\e931";
}
.icon-multifile:before {
  content: "\e930";
}
.icon-handle_bar:before {
  content: "\e92f";
}
.icon-check:before {
  content: "\e92e";
}
.icon-patch_management:before {
  content: "\e92d";
}
.icon-calendar:before {
  content: "\e92c";
}
.icon-expand:before {
  content: "\e92b";
}
.icon-registry:before {
  content: "\e92a";
}
.icon-process:before {
  content: "\e929";
}
.icon-file:before {
  content: "\e928";
}
.icon-endpoint:before {
  content: "\e927";
}
.icon-domain:before {
  content: "\e926";
}
.icon-view-more:before {
  content: "\e925";
}
.icon-severity:before {
  content: "\e924";
}
.icon-network-splitter:before {
  content: "\e923";
}
.icon-circle-whatsnew:before {
  content: "\e922";
}
.icon-active-directory:before {
  content: "\e921";
}
.icon-encryption:before {
  content: "\e920";
}
.icon-gravityzone:before {
  content: "\e91f";
}
.icon-question:before {
  content: "\e91e";
}
.icon-pending:before {
  content: "\e91d";
}
.icon-fail:before {
  content: "\e91c";
}
.icon-checked:before {
  content: "\e91b";
}
.icon-notification-bell:before {
  content: "\e91a";
}
.icon-helpmode:before {
  content: "\e919";
}
.icon-main-tools:before {
  content: "\e918";
}
.icon-not-available:before {
  content: "\e917";
}
.icon-threat-unresolved:before {
  content: "\e916";
}
.icon-threat-resolved:before {
  content: "\e915";
}
.icon-no-threat:before {
  content: "\e914";
}
.icon-snapshot:before {
  content: "\e913";
}
.icon-automatic-submission:before {
  content: "\e912";
}
.icon-copy-clipboard:before {
  content: "\e911";
}
.icon-sva:before {
  content: "\e910";
}
.icon-reports:before {
  content: "\e90f";
}
.icon-modular-settings-key:before {
  content: "\e90e";
}
.icon-mail-square:before {
  content: "\e90d";
}
.icon-mail:before {
  content: "\e90c";
}
.icon-logo-square:before {
  content: "\e90b";
}
.icon-logo:before {
  content: "\e90a";
}
.icon-sva-vshield:before {
  content: "\e909";
}
.icon-sva-nsx:before {
  content: "\e908";
}
.icon-sva-hvi:before {
  content: "\e907";
}
.icon-overview:before {
  content: "\e906";
}
.icon-modules:before {
  content: "\e905";
}
.icon-additional-information:before {
  content: "\e904";
}
.icon-security-servers:before {
  content: "\e903";
}
.icon-exclamation:before {
  content: "\e902";
}
.icon-handle:before {
  content: "\e901";
}
.icon-edr:before {
  content: "\e900";
}
.icon-unknown_icon:before {
  content: "\e9ab";
}
.icon-edr_incident_info_tab_icon:before {
  content: "\e9ac";
}
.icon-Container-AWS:before {
  content: "\e9ad";
}
.icon-Container-Azure:before {
  content: "\e9ae";
}
.icon-Container-GCP:before {
  content: "\e9af";
}
.icon-Database-AWS:before {
  content: "\e9b0";
}
.icon-Database-Azure:before {
  content: "\e9b1";
}
.icon-Database-GCP:before {
  content: "\e9b2";
}
.icon-Integration-AD:before {
  content: "\e9b3";
}
.icon-Integration-AWS:before {
  content: "\e9b4";
}
.icon-Integration-Azure-AD:before {
  content: "\e9b5";
}
.icon-Integration-Azure:before {
  content: "\e9b6";
}
.icon-Integration-GCP:before {
  content: "\e9b7";
}
.icon-Integration-Office365:before {
  content: "\e9b8";
}
.icon-Server-AWS:before {
  content: "\e9b9";
}
.icon-Server-Azure:before {
  content: "\e9ba";
}
.icon-Server-GCP:before {
  content: "\e9bb";
}
.icon-Storage-AWS:before {
  content: "\e9bc";
}
.icon-Storage-Azure:before {
  content: "\e9bd";
}
.icon-Storage-GCP:before {
  content: "\e9be";
}
.icon-TOR-node:before {
  content: "\e9bf";
}
.icon-User-AD:before {
  content: "\e9c0";
}
.icon-User-AWS:before {
  content: "\e9c1";
}
.icon-User-GCP:before {
  content: "\e9c2";
}
.icon-User-Generic:before {
  content: "\e9c3";
}
.icon-User-Office365:before {
  content: "\e9c4";
}
.icon-Virtual-Desktop-AWS:before {
  content: "\e9c5";
}
.icon-Virtual-Desktop-Azure:before {
  content: "\e9c6";
}
.icon-Virtual-Desktop-GCP:before {
  content: "\e9c7";
}
.icon-Virtual-Server-AWS:before {
  content: "\e9c8";
}
.icon-Virtual-Server-Azure:before {
  content: "\e9c9";
}
.icon-Virtual-Server-GCP:before {
  content: "\e9ca";
}
.icon-alert-icon-hexagon:before {
  content: "\e9cb";
}
.icon-Storage:before {
  content: "\e9cc";
}
.icon-Database:before {
  content: "\e9cd";
}
.icon-Container_filled:before {
  content: "\e9ce";
}
.icon-Transfer_icon:before {
  content: "\e9cf";
}
.icon-copy_clipboard_Nirvana:before {
  content: "\e9d0";
}
.icon-others:before {
  content: "\e9d1";
}
.icon-Virtual-Desktop-Generic:before {
  content: "\e9d2";
}
.icon-Response:before {
  content: "\e9d3";
}
.icon-User-Azure:before {
  content: "\e9d4";
}
.icon-remote_shell:before {
  content: "\e9d5";
}
.icon-Application:before {
  content: "\e9d6";
}
.icon-Email-attachment:before {
  content: "\e9d7";
}
.icon-Email-subject:before {
  content: "\e9d8";
}
.icon-Generic-resource:before {
  content: "\e9d9";
}
.icon-KeyVault:before {
  content: "\e9da";
}
.icon-URL:before {
  content: "\e9db";
}
.icon-incident-trigger:before {
  content: "\e9dc";
}
.icon-Flow:before {
  content: "\e9dd";
}
.icon-Launch-template:before {
  content: "\e9de";
}
.icon-Share-link-or-file:before {
  content: "\e9df";
}
.icon-SSH:before {
  content: "\e9e0";
}
.icon-history_overview:before {
  content: "\e9e1";
}
.icon-resource_automation_account:before {
  content: "\e9e2";
}
.icon-resource_automation_account_hook:before {
  content: "\e9e3";
}
.icon-resource_API:before {
  content: "\e9e4";
}
.icon-resource_certificate_authority:before {
  content: "\e9e5";
}
.icon-resource_bucket:before {
  content: "\e9e6";
}
.icon-tags:before {
  content: "\e9e7";
}
.icon-entity_Google_Workspace:before {
  content: "\e9f1";
}
.icon-resource_user_groups:before {
  content: "\e9f2";
}
.icon-resource_account_principal:before {
  content: "\e9f3";
}
.icon-jira_project:before {
  content: "\e9f4";
}
.icon-product_atlassian_bitbucket:before {
  content: "\e9f5";
}
.icon-confluence_page:before {
  content: "\e9f6";
}
.icon-confluence_space:before {
  content: "\e9f7";
}
.icon-bitbucket_repository:before {
  content: "\e9f8";
}
.icon-bitbucket_project:before {
  content: "\e9f9";
}
.icon-atlassian:before {
  content: "\e9fa";
}
.icon-user_atlassian:before {
  content: "\e9fb";
}
.icon-product_atlassian_jira:before {
  content: "\e9fc";
}
.icon-product_atlassian_confluence:before {
  content: "\e9fd";
}
/**
*   Nirvana design system icons
    2023-11-15
*/

@font-face {
  font-family: 'ds-bitdefender';
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/icons/ds-gz_main.eot?jbvyvc');
  src: url($gzConsoleAssetsPrefix + 'assets/fonts/icons/ds-gz_main.eot?jbvyvc#iefix') format('embedded-opentype'),
    url($gzConsoleAssetsPrefix + 'assets/fonts/icons/ds-gz_main.ttf?jbvyvc') format('truetype'),
    url($gzConsoleAssetsPrefix + 'assets/fonts/icons/ds-gz_main.woff?jbvyvc') format('woff'),
    url($gzConsoleAssetsPrefix + 'assets/fonts/icons/ds-gz_main.svg?jbvyvc#ds-bitdefender') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^='ds-icon-'],
[class*=' ds-icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'ds-bitdefender' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ds-icon-gz_cloud_security:before {
  content: "\e9a5";
}
.ds-icon-b_symbol_bold:before {
  content: "\e9a3";
}
.ds-icon-menu_cloud_sec:before {
  content: "\e9a4";
}
.ds-icon-download:before {
  content: "\e9a2";
}
.ds-icon-menu_network:before {
  content: "\e991";
}
.ds-icon-menu_mobile_security:before {
  content: "\e992";
}
.ds-icon-encryption:before {
  content: "\e993";
}
.ds-icon-patch_management:before {
  content: "\e994";
}
.ds-icon-SVA:before {
  content: "\e995";
}
.ds-icon-registry:before {
  content: "\e99d";
}
.ds-icon-other:before {
  content: "\e996";
}
.ds-icon-add_search:before {
  content: "\e98e";
}
.ds-icon-edit_pen:before {
  content: "\e988";
}
.ds-icon-container_hosts:before {
  content: "\e984";
}
.ds-icon-containers:before {
  content: "\e985";
}
.ds-icon-windows:before {
  content: "\e997";
}
.ds-icon-linux:before {
  content: "\e986";
}
.ds-icon-MacOS:before {
  content: "\e987";
}
.ds-icon-security_servers:before {
  content: "\e989";
}
.ds-icon-devices:before {
  content: "\e998";
}
.ds-icon-virtual_machines:before {
  content: "\e98a";
}
.ds-icon-win_servers:before {
  content: "\e98b";
}
.ds-icon-win_workstations:before {
  content: "\e98c";
}
.ds-icon-user_menu:before {
  content: "\e981";
}
.ds-icon-help_support:before {
  content: "\e980";
}
.ds-icon-whats_new:before {
  content: "\e97d";
}
.ds-icon-notification_bell:before {
  content: "\e97e";
}
.ds-icon-product_trials_hub:before {
  content: "\e97f";
}
.ds-icon-trial_card_1:before {
  content: "\e99e";
}
.ds-icon-trial_card_2:before {
  content: "\e99f";
}
.ds-icon-trial_card_3:before {
  content: "\e9a0";
}
.ds-icon-delete_large:before {
  content: "\e929";
}
.ds-icon-copy_clipboard:before {
  content: "\e926";
}
.ds-icon-bitdefender_logo_bw_web:before {
  content: "\e924";
}
.ds-icon-bitdefender_menu_B:before {
  content: "\e925";
}
.ds-icon-GZ_mobile_security:before {
  content: "\e999";
}
.ds-icon-add:before {
  content: "\e900";
}
.ds-icon-arrow_down_expand:before {
  content: "\e901";
}
.ds-icon-arrow_left_collapse:before {
  content: "\e902";
}
.ds-icon-arrow_right_expand:before {
  content: "\e903";
}
.ds-icon-arrow_up_collapse:before {
  content: "\e904";
}
.ds-icon-calendar_next:before {
  content: "\e905";
}
.ds-icon-calendar_prev:before {
  content: "\e906";
}
.ds-icon-calendar:before {
  content: "\e907";
}
.ds-icon-cancel:before {
  content: "\e908";
}
.ds-icon-clear:before {
  content: "\e909";
}
.ds-icon-drag:before {
  content: "\e90a";
}
.ds-icon-dropdown_arrow:before {
  content: "\e90b";
}
.ds-icon-filter_applied:before {
  content: "\e90c";
}
.ds-icon-filter:before {
  content: "\e90d";
}
.ds-icon-more:before {
  content: "\e90e";
}
.ds-icon-notification_close:before {
  content: "\e90f";
}
.ds-icon-exclamation_wizard:before {
  content: "\e99a";
}
.ds-icon-failed:before {
  content: "\e9a1";
}
.ds-icon-notification_info:before {
  content: "\e910";
}
.ds-icon-notification_warning:before {
  content: "\e911";
}
.ds-icon-notification_success:before {
  content: "\e912";
}
.ds-icon-notification_negative:before {
  content: "\e913";
}
.ds-icon-pagination_first_page:before {
  content: "\e914";
}
.ds-icon-pagination_last_page:before {
  content: "\e915";
}
.ds-icon-panel_next:before {
  content: "\e916";
}
.ds-icon-panel_prev:before {
  content: "\e917";
}
.ds-icon-resize_handle:before {
  content: "\e98f";
}
.ds-icon-refresh:before {
  content: "\e918";
}
.ds-icon-resize:before {
  content: "\e919";
}
.ds-icon-search:before {
  content: "\e91a";
}
.ds-icon-settings:before {
  content: "\e91b";
}
.ds-icon-sorting_down:before {
  content: "\e91c";
}
.ds-icon-sorting_unsorted:before {
  content: "\e91d";
}
.ds-icon-sorting_up:before {
  content: "\e91e";
}
.ds-icon-text-area:before {
  content: "\e91f";
}
.ds-icon-textbox_decrease:before {
  content: "\e920";
}
.ds-icon-textbox_increase:before {
  content: "\e921";
}
.ds-icon-validation_checked:before {
  content: "\e922";
}
.ds-icon-validation_error:before {
  content: "\e923";
}
.ds-icon-info:before {
  content: "\e927";
}
.ds-icon-expand:before {
  content: "\e928";
}
.ds-icon-help:before {
  content: "\e92a";
}
.ds-icon-Resource-development_2c:before {
  content: "\e92b";
}
.ds-icon-Reconnaissance_2c:before {
  content: "\e92c";
}
.ds-icon-Persistence_4c:before {
  content: "\e92d";
}
.ds-icon-Privilege-escalation_2c:before {
  content: "\e92e";
}
.ds-icon-Lateral-movement_2c:before {
  content: "\e92f";
}
.ds-icon-Initial-access_2c:before {
  content: "\e930";
}
.ds-icon-Defense-evasion_4c:before {
  content: "\e931";
}
.ds-icon-Impact_2c:before {
  content: "\e932";
}
.ds-icon-Exfiltration_2c:before {
  content: "\e933";
}
.ds-icon-Credential-access_2c:before {
  content: "\e934";
}
.ds-icon-Command-and-control_2c:before {
  content: "\e935";
}
.ds-icon-Execution_2c:before {
  content: "\e936";
}
.ds-icon-Discovery_2c:before {
  content: "\e938";
}
.ds-icon-Collection_2c:before {
  content: "\e939";
}
.ds-icon-export:before {
  content: "\e937";
}
.ds-icon-delete:before {
  content: "\e93a";
}
.ds-icon-favorites-star_outline:before {
  content: "\e93b";
}
.ds-icon-favorites_star_filled:before {
  content: "\e93c";
}
.ds-icon-resource_generic:before {
  content: "\e93d";
}
.ds-icon-resource_email:before {
  content: "\e93e";
}
.ds-icon-resource_application:before {
  content: "\e93f";
}
.ds-icon-resource_key_vault:before {
  content: "\e940";
}
.ds-icon-resource_URL:before {
  content: "\e941";
}
.ds-icon-resource_file:before {
  content: "\e942";
}
.ds-icon-resource_user_role:before {
  content: "\e943";
}
.ds-icon-resource_policy:before {
  content: "\e944";
}
.ds-icon-resource_share_link:before {
  content: "\e945";
}
.ds-icon-resource_flow:before {
  content: "\e946";
}
.ds-icon-resource_SSH_key:before {
  content: "\e947";
}
.ds-icon-resource_launch_template:before {
  content: "\e948";
}
.ds-icon-resource_email_subject:before {
  content: "\e949";
}
.ds-icon-resource_email_attachment:before {
  content: "\e94a";
}
.ds-icon-resource_automation_account:before {
  content: "\e94b";
}
.ds-icon-resource_automation_account_hook:before {
  content: "\e94c";
}
.ds-icon-resource_API:before {
  content: "\e94d";
}
.ds-icon-resource_certificate_authority:before {
  content: "\e94e";
}
.ds-icon-resource_bucket:before {
  content: "\e94f";
}
.ds-icon-resource_user_groups:before {
  content: "\e982";
}
.ds-icon-resource_service_principal:before {
  content: "\e983";
}
.ds-icon-attacker:before {
  content: "\e99b";
}
.ds-icon-external_drive:before {
  content: "\e99c";
}
.ds-icon-entity_endpoint:before {
  content: "\e950";
}
.ds-icon-entity_server:before {
  content: "\e951";
}
.ds-icon-entity_mobile_device:before {
  content: "\e952";
}
.ds-icon-entity_printer:before {
  content: "\e953";
}
.ds-icon-entity_router:before {
  content: "\e954";
}
.ds-icon-entity_IOT:before {
  content: "\e955";
}
.ds-icon-entity_user_generic:before {
  content: "\e956";
}
.ds-icon-entity_user_AWS:before {
  content: "\e957";
}
.ds-icon-entity_user_GCP:before {
  content: "\e958";
}
.ds-icon-entity_user_AD:before {
  content: "\e959";
}
.ds-icon-entity_user_Azure_AD:before {
  content: "\e95a";
}
.ds-icon-entity_user_O365:before {
  content: "\e990";
}
.ds-icon-entity_AWS:before {
  content: "\e95b";
}
.ds-icon-entity_Azure:before {
  content: "\e95c";
}
.ds-icon-entity_GCP:before {
  content: "\e95d";
}
.ds-icon-entity_AD:before {
  content: "\e95e";
}
.ds-icon-entity_O365:before {
  content: "\e95f";
}
.ds-icon-entity_Azure_AD:before {
  content: "\e960";
}
.ds-icon-entity_virtual_server_AWS:before {
  content: "\e961";
}
.ds-icon-entity_container_AWS:before {
  content: "\e962";
}
.ds-icon-entity_service_AWS:before {
  content: "\e963";
}
.ds-icon-entity_database_AWS:before {
  content: "\e964";
}
.ds-icon-entity_storage_AWS:before {
  content: "\e965";
}
.ds-icon-entity_end_user_computing_AWS:before {
  content: "\e966";
}
.ds-icon-entity_virtual_server_Azure:before {
  content: "\e967";
}
.ds-icon-entity_container_Azure:before {
  content: "\e968";
}
.ds-icon-entity_service_Azure:before {
  content: "\e969";
}
.ds-icon-entity_database_Azure:before {
  content: "\e96a";
}
.ds-icon-entity_storage_Azure:before {
  content: "\e96b";
}
.ds-icon-entity_end_user_computing_Azure:before {
  content: "\e96c";
}
.ds-icon-entity_virtual_server_GCP:before {
  content: "\e96d";
}
.ds-icon-entity_container_GCP:before {
  content: "\e96e";
}
.ds-icon-entity_service_GCP:before {
  content: "\e96f";
}
.ds-icon-entity_database_GCP:before {
  content: "\e970";
}
.ds-icon-entity_storage_GCP:before {
  content: "\e971";
}
.ds-icon-entity_end_user_computing_GCP:before {
  content: "\e972";
}
.ds-icon-entity_IP_domain_DNS_DGA:before {
  content: "\e973";
}
.ds-icon-entity_cloud_storage:before {
  content: "\e974";
}
.ds-icon-entity_TOR_node:before {
  content: "\e975";
}
.ds-icon-Endpoint_graph_EDR:before {
  content: "\e976";
}
.ds-icon-Organization_graph_XDR:before {
  content: "\e977";
}
.ds-icon-live-view-button:before {
  content: "\e978";
}
.ds-icon-fullscreen:before {
  content: "\e979";
}
.ds-icon-reports:before {
  content: "\e97a";
}
.ds-icon-resize-both-axes:before {
  content: "\e97b";
}
.ds-icon-entity_Google_Workspace:before {
  content: "\e97c";
}
.ds-icon-feedback_notes:before {
  content: "\e98d";
}
.ds-icon-MDR:before {
  content: "\e9a6";
}
.ds-icon-intelli_zone:before {
  content: "\e9a7";
}
